import { render } from "./ascDescBlock.vue?vue&type=template&id=657f104e&scoped=true"
import script from "./ascDescBlock.vue?vue&type=script&lang=js"
export * from "./ascDescBlock.vue?vue&type=script&lang=js"

import "./ascDescBlock.vue?vue&type=style&index=0&id=657f104e&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-657f104e"]])

export default __exports__